function createImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.addEventListener("load", () => resolve(img));
    img.addEventListener("error", (e) => reject(e));
    img.setAttribute("crossOrigin", "anonymous");
    img.src = url;
  });
}

const toRad = (deg) => (deg * Math.PI) / 180;

function rotatedSize(w, h, rotation) {
  const r = toRad(rotation);
  return {
    width: Math.abs(Math.cos(r) * w) + Math.abs(Math.sin(r) * h),
    height: Math.abs(Math.sin(r) * w) + Math.abs(Math.cos(r) * h),
  };
}

// Crop + rotate. Returns a Blob. Background fill covers any area outside the
// source image (only relevant when the crop extends past the image bounds).
export async function getCroppedBlob(imageSrc, cropPixels, rotation = 0, {
  mime = "image/jpeg", quality = 0.92, bg = "#ffffff",
} = {}) {
  const image = await createImage(imageSrc);
  const { width: bw, height: bh } = rotatedSize(image.width, image.height, rotation);

  const temp = document.createElement("canvas");
  const tctx = temp.getContext("2d");
  temp.width = bw;
  temp.height = bh;
  tctx.translate(bw / 2, bh / 2);
  tctx.rotate(toRad(rotation));
  tctx.drawImage(image, -image.width / 2, -image.height / 2);

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  canvas.width = Math.round(cropPixels.width);
  canvas.height = Math.round(cropPixels.height);

  if (mime !== "image/png") {
    ctx.fillStyle = bg || "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }
  ctx.drawImage(
    temp,
    cropPixels.x, cropPixels.y, cropPixels.width, cropPixels.height,
    0, 0, canvas.width, canvas.height,
  );

  return new Promise((resolve) => canvas.toBlob((b) => resolve(b), mime, quality));
}

export function readFileAsDataURL(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
}
